import { render, staticRenderFns } from "./JobCardSkeleton.vue?vue&type=template&id=68977f78&scoped=true&"
import script from "./JobCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./JobCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./JobCardSkeleton.vue?vue&type=style&index=0&id=68977f78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68977f78",
  null
  
)

export default component.exports